import { render, staticRenderFns } from "./PushNotification.vue?vue&type=template&id=0270a31b"
import script from "./PushNotification.vue?vue&type=script&lang=js"
export * from "./PushNotification.vue?vue&type=script&lang=js"
import style0 from "./PushNotification.vue?vue&type=style&index=0&id=0270a31b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports